import { makeAutoObservable } from "mobx";
import {
  getActivityLogById,
  pagingActivityLogByEmr,
} from "app/services/ActivityLogService";
import moment from "moment";
import { toast } from "react-toastify";

export default class ActivityLogStore {
  searchActivityLog = { pageIndex: 1, pageSize: 10 };
  selectActivityLog = {};
  pageActivityLog = null;
  openPopup = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingActivityLog = async () => {
    try {
      const { data } = await pagingActivityLogByEmr(this.searchActivityLog);
      this.pageActivityLog = data;
    } catch (error) {
      console.error("Lỗi khi phân trang nhật ký hoạt động:", error);
    }
  };

  getActivityLogById = (id) => {
    getActivityLogById(id).then(({ data }) => {
      if (data) {
        let { logDate } = data;
        if (logDate) {
          const rawDate = [...(logDate || [])];
          let modifyDate;
          if (Array.isArray(rawDate) && rawDate.length === 6) {
            const [year, month, day, hour, minute, second, someThing] = rawDate;
            modifyDate = moment([year, month - 1, day, hour, minute, second]); // Tháng - 1
            this.selectActivityLog = { ...data, logDate: modifyDate };
          }
        } else {
          this.selectActivityLog = data;
        }
      } else {
        toast.error("Lỗi lấy dữ liệu");
      }
      this.openPopup = true;
    });
  };

  handleClosePopup = () => {
    this.openPopup = false;
  };

  handleChangeFormSearch = (searchActivityLog) => {
    this.searchActivityLog = {
      ...this.searchActivityLog,
      ...searchActivityLog,
    };
    this.pagingActivityLog();
  };

  resetStore = () => {
    this.searchActivityLog = { pageIndex: 1, pageSize: 10 };
    this.pageActivityLog = null;
    this.selectActivityLog = {};
  };
}
